import {Types} from 'mongoose';
import {
    USER_ROLE_CIRCLE_KEEPER,
    USER_ROLE_COACH,
    USER_ROLE_CONCILIATOR,
    USER_ROLE_CONSULTANT,
    USER_ROLE_COORDINATOR,
    USER_ROLE_MEDIATOR,
    USER_ROLE_OTHER_ID,
} from './user-roles.const';

export const USER_ROLE = {
    type: 'User Role',
    category: 'System',
    value: [
        {label: USER_ROLE_CIRCLE_KEEPER, _id: new Types.ObjectId('507f191e810c19729de86101')},
        {label: USER_ROLE_COACH, _id: new Types.ObjectId('507f191e810c19729de86102')},
        {label: USER_ROLE_CONCILIATOR, _id: new Types.ObjectId('507f191e810c19729de86103')},
        {label: USER_ROLE_COORDINATOR, _id: new Types.ObjectId('507f191e810c19729de86104')},
        {label: USER_ROLE_CONSULTANT, _id: new Types.ObjectId('507f191e810c19729de86105')},
        {label: 'Facilitator', _id: new Types.ObjectId('507f191e810c19729de86106')},
        {label: USER_ROLE_MEDIATOR, _id: new Types.ObjectId('507f191e810c19729de86107')},
        {label: 'Observer', _id: new Types.ObjectId('507f191e810c19729de86108')},
        {label: 'Trainer', _id: new Types.ObjectId('507f191e810c19729de86109')},
        {label: 'Peer Mediator', _id: new Types.ObjectId('507f191e810c19729de86110')},
        {label: 'Other', _id: new Types.ObjectId(USER_ROLE_OTHER_ID)},
    ].map(d => ({...d, active: true})),
};
